
import { Link } from 'react-router-dom';

const DiningSection = () => {
  return (
    <section className="py-20 bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-cyan-500"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img
                  src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/40e1c930337bd7c6b1c4b4d8fa9b3f27.jpeg"
                  alt="Delicious burger with fries at Ocean View Sports Pub"
                  className="w-full h-64 object-cover rounded-2xl shadow-xl"
                />
                <img
                  src="https://theocean-view.com/wp-content/uploads/2016/03/phoca_thumb_l_dsc_0528.jpg"
                  alt="Ocean View Sports Pub interior dining area"
                  className="w-full h-48 object-cover rounded-2xl shadow-xl"
                />
              </div>
              <div className="space-y-4 pt-8">
                <img
                  src="https://theocean-view.com/wp-content/uploads/2016/03/phoca_thumb_l_ov74.jpg"
                  alt="Ocean View outdoor patio dining at night"
                  className="w-full h-48 object-cover rounded-2xl shadow-xl"
                />
                <img
                  src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/584321d64c6ce1e0cdebfc9bbc22482c.jpeg"
                  alt="Fresh seafood and burgers at Ocean View"
                  className="w-full h-64 object-cover rounded-2xl shadow-xl"
                />
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 font-serif">
              Sports Pub & Restaurant
            </h2>
            <p className="text-xl text-slate-300 mb-6 leading-relaxed">
              Join us in our sports pub and restaurant or on our outdoor patio, serving classic American fare and late-night bites. Fresh seafood, juicy burgers, and ice-cold drinks in a vibrant Keys atmosphere.
            </p>
            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <i className="ri-restaurant-line text-2xl text-blue-400"></i>
                <span className="text-slate-300">Fresh seafood and classic American cuisine</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-beer-line text-2xl text-blue-400"></i>
                <span className="text-slate-300">Full bar with craft beers and cocktails</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-tv-line text-2xl text-blue-400"></i>
                <span className="text-slate-300">Multiple screens for sports viewing</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-sun-line text-2xl text-blue-400"></i>
                <span className="text-slate-300">Outdoor patio with ocean breezes</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/menu"
                className="inline-flex items-center justify-center px-6 py-3 bg-white text-slate-900 rounded-lg font-semibold hover:bg-slate-100 transition-colors whitespace-nowrap"
              >
                View Full Menu
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <a
                href="https://www.toasttab.com/the-ocean-view-84500-overseas-hwy"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-slate-900 transition-colors whitespace-nowrap"
              >
                Order Online
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiningSection;
